export default __webpack_public_path__ + "88c4f95cfb5adb16dd882cd70e65e3c1.png";